import { j as ne } from "../../jsx-runtime-B6kdoens.js";
import re, { useMemo as we, useRef as Ne, useCallback as Nt } from "react";
import { g as Ur } from "../../_commonjsHelpers-DaMA6jEr.js";
import { a as Et } from "../../index-CROKJrb5.js";
import { u as Vr } from "../../use-dimensions-CSpaxs3M.js";
import { a as Kr } from "../../use-window-size-CTHYqDff.js";
import { u as Xr } from "../../use-merge-refs-DEJnLwh4.js";
import { u as Yr } from "../../use-bounding-client-rect-DuREs_dA.js";
import { c as Gr, f as Jr } from "../../create-component-CBAeEoQ6.js";
import { a as kt } from "../../as-num-DQjLjHSI.js";
import { BreakpointSizes as Wt, BreakpointValues as Qr, BreakpointNames as Zr } from "../../models/index.ts.js";
import { getClosestIndex as Ht } from "../../helpers/index.ts.js";
import { Button as en } from "../Button/index.js";
import { PlaceholderIcon as Xt } from "../Icon/icons/PlaceholderIcon/index.js";
var st = {}, Yt = {}, Gt = {}, Ee = {};
Object.defineProperty(Ee, "__esModule", {
  value: !0
});
Ee.useSlideIntersectionObserver = void 0;
var Te = re;
function tn(e, r) {
  return on(e) || an(e, r) || nn(e, r) || rn();
}
function rn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nn(e, r) {
  if (e) {
    if (typeof e == "string") return Lt(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Lt(e, r);
  }
}
function Lt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++)
    a[t] = e[t];
  return a;
}
function an(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], d = !0, l = !1, g, m;
    try {
      for (t = t.call(e); !(d = (g = t.next()).done) && (a.push(g.value), !(r && a.length === r)); d = !0)
        ;
    } catch (b) {
      l = !0, m = b;
    } finally {
      try {
        !d && t.return != null && t.return();
      } finally {
        if (l) throw m;
      }
    }
    return a;
  }
}
function on(e) {
  if (Array.isArray(e)) return e;
}
var un = function(r, t, a) {
  var d = (0, Te.useState)(), l = tn(d, 2), g = l[0], m = l[1], b = (0, Te.useRef)(a);
  return (0, Te.useEffect)(function() {
    b.current = a;
  }, [a]), (0, Te.useEffect)(function() {
    var c = r == null ? void 0 : r.current, C = t == null ? void 0 : t.current;
    if (!(!window.IntersectionObserver || !c || !C)) {
      var S = new IntersectionObserver(function(s) {
        s.forEach(function(w) {
          m(w), b.current(w);
        });
      }, {
        threshold: [0.05, 0.95],
        root: C
      });
      return S.observe(c), function() {
        return S.disconnect();
      };
    }
  }, [r, t]), g;
};
Ee.useSlideIntersectionObserver = un;
(function(e) {
  function r(S) {
    "@babel/helpers - typeof";
    return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(s) {
      return typeof s;
    } : function(s) {
      return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
    }, r(S);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = l(re), a = Ee;
  function d(S) {
    if (typeof WeakMap != "function") return null;
    var s = /* @__PURE__ */ new WeakMap(), w = /* @__PURE__ */ new WeakMap();
    return (d = function(p) {
      return p ? w : s;
    })(S);
  }
  function l(S, s) {
    if (S && S.__esModule)
      return S;
    if (S === null || r(S) !== "object" && typeof S != "function")
      return { default: S };
    var w = d(s);
    if (w && w.has(S))
      return w.get(S);
    var v = {}, p = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var i in S)
      if (i !== "default" && Object.prototype.hasOwnProperty.call(S, i)) {
        var n = p ? Object.getOwnPropertyDescriptor(S, i) : null;
        n && (n.get || n.set) ? Object.defineProperty(v, i, n) : v[i] = S[i];
      }
    return v.default = S, w && w.set(S, v), v;
  }
  var g = function(s, w) {
    return "".concat(w ? 100 / (3 * s) : 100 / s, "%");
  }, m = function(s, w, v, p, i, n, f, y, _, M, R) {
    var O = R ?? g(s, p), A = v ? 1 : 0, B = n === "fade" ? 200 : 500, u = "auto";
    return _ && (M ? u = "100%" : v ? u = "auto" : u = "0"), {
      width: O,
      height: u,
      padding: "0 ".concat(i ? i / 2 : 0, "px"),
      transition: n ? "".concat(f || B, "ms ease 0s") : void 0,
      transform: n === "zoom" ? "scale(".concat(w && v ? 1 : y || 0.85, ")") : void 0,
      opacity: n === "fade" ? A : 1
    };
  }, b = function(s, w, v) {
    return v === "prev-cloned" ? s - w : v === "next-cloned" ? s + w : s;
  }, c = function(s) {
    var w, v = s.count, p = s.children, i = s.index, n = s.isCurrentSlide, f = s.typeOfSlide, y = s.wrapAround, _ = s.cellSpacing, M = s.slideWidth, R = s.animation, O = s.speed, A = s.zoomScale, B = s.onVisibleSlideHeightChange, u = s.adaptiveHeight, h = s.initializedAdaptiveHeight, o = s.updateIOEntry, D = s.id, I = s.carouselRef, T = s.carouselId, N = s.tabbed, j = y ? b(i, v, f) : i, E = (0, t.useRef)(null), q = (0, a.useSlideIntersectionObserver)(E, I, function(le) {
      o(D, (le == null ? void 0 : le.intersectionRatio) >= 0.95);
    }), G = !!(q != null && q.isIntersecting), J = ((w = q == null ? void 0 : q.intersectionRatio) !== null && w !== void 0 ? w : 1) >= 0.95, ue = (0, t.useRef)(!1);
    (0, t.useEffect)(function() {
      var le = E.current;
      if (le) {
        var me, he = (me = le.getBoundingClientRect()) === null || me === void 0 ? void 0 : me.height, be = ue.current;
        G && !be ? B(j, he) : !G && be && B(j, null), ue.current = G;
      }
    }, [j, G, B]);
    var $e = n && J ? " slide-current" : "";
    return /* @__PURE__ */ t.default.createElement("div", {
      ref: E,
      inert: J ? void 0 : "true",
      className: "slide".concat($e).concat(f ? " ".concat(f) : "").concat(J ? " slide-visible" : ""),
      style: m(v, n, J, y, _, R, O, A, u, h, M),
      id: f ? void 0 : "".concat(T, "-slide-").concat(i + 1),
      role: N ? "tabpanel" : "group",
      "aria-roledescription": N ? void 0 : "slide"
    }, p);
  }, C = c;
  e.default = C;
})(Gt);
var ct = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.defaultRenderAnnounceSlideMessage = e.default = void 0;
  var r = t(re);
  function t(m) {
    return m && m.__esModule ? m : { default: m };
  }
  var a = {
    position: "absolute",
    width: "1px",
    height: "1px",
    overflow: "hidden",
    padding: 0,
    margin: "-1px",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    border: 0
  }, d = function(b) {
    var c = b.message, C = b.ariaLive, S = C === void 0 ? "polite" : C;
    return /* @__PURE__ */ r.default.createElement("div", {
      "aria-live": S,
      "aria-atomic": "true",
      style: a,
      tabIndex: -1
    }, c);
  }, l = function(b) {
    var c = b.currentSlide, C = b.count;
    return "Slide ".concat(c + 1, " of ").concat(C);
  };
  e.defaultRenderAnnounceSlideMessage = l;
  var g = d;
  e.default = g;
})(ct);
var ge = {}, V = {}, H = {};
Object.defineProperty(H, "__esModule", {
  value: !0
});
H.ScrollMode = H.Positions = H.Directions = H.Alignment = void 0;
var rt;
H.Alignment = rt;
(function(e) {
  e.Center = "center", e.Right = "right", e.Left = "left";
})(rt || (H.Alignment = rt = {}));
var nt;
H.Directions = nt;
(function(e) {
  e.Next = "next", e.Prev = "prev", e.Up = "up", e.Down = "down";
})(nt || (H.Directions = nt = {}));
var at;
H.Positions = at;
(function(e) {
  e.TopLeft = "TopLeft", e.TopCenter = "TopCenter", e.TopRight = "TopRight", e.CenterLeft = "CenterLeft", e.CenterCenter = "CenterCenter", e.CenterRight = "CenterRight", e.BottomLeft = "BottomLeft", e.BottomCenter = "BottomCenter", e.BottomRight = "BottomRight";
})(at || (H.Positions = at = {}));
var it;
H.ScrollMode = it;
(function(e) {
  e.page = "page", e.remainder = "remainder";
})(it || (H.ScrollMode = it = {}));
var te = {}, $t;
function Jt() {
  if ($t) return te;
  $t = 1, Object.defineProperty(te, "__esModule", {
    value: !0
  }), te.getPrevMoveIndex = te.getNextMoveIndex = te.getDefaultSlideIndex = te.getBoundedIndex = void 0;
  var e = ye(), r = H, t = function(m, b, c, C, S, s, w) {
    return b ? c + S : c >= C - 1 || w === "left" && c >= C - s ? c : m === r.ScrollMode.remainder && w === "left" ? Math.min(c + S, C - s) : Math.min(c + S, C - 1);
  };
  te.getNextMoveIndex = t;
  var a = function(m, b, c, C, S, s) {
    return b ? c - C : c <= 0 || s === "right" && c <= S - 1 ? c : m === r.ScrollMode.remainder && s === "right" ? Math.max(c - C, S - 1) : Math.max(c - C, 0);
  };
  te.getPrevMoveIndex = a;
  var d = function(m, b, c, C, S, s, w) {
    if (m !== void 0)
      return m;
    var v = (0, e.getDotIndexes)(b, C, w, c, !1, S);
    return s ? v[v.length - 1] : v[0];
  };
  te.getDefaultSlideIndex = d;
  var l = function(m, b) {
    return (m % b + b) % b;
  };
  return te.getBoundedIndex = l, te;
}
var jt;
function ye() {
  if (jt) return V;
  jt = 1;
  function e(i) {
    "@babel/helpers - typeof";
    return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
      return typeof n;
    } : function(n) {
      return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
    }, e(i);
  }
  Object.defineProperty(V, "__esModule", {
    value: !0
  }), V.prevButtonDisabled = V.nextButtonDisabled = V.getDotIndexes = V.PreviousButton = V.PagingDots = V.NextButton = void 0;
  var r = l(re), t = H, a = Jt();
  function d(i) {
    if (typeof WeakMap != "function") return null;
    var n = /* @__PURE__ */ new WeakMap(), f = /* @__PURE__ */ new WeakMap();
    return (d = function(_) {
      return _ ? f : n;
    })(i);
  }
  function l(i, n) {
    if (i && i.__esModule)
      return i;
    if (i === null || e(i) !== "object" && typeof i != "function")
      return { default: i };
    var f = d(n);
    if (f && f.has(i))
      return f.get(i);
    var y = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var M in i)
      if (M !== "default" && Object.prototype.hasOwnProperty.call(i, M)) {
        var R = _ ? Object.getOwnPropertyDescriptor(i, M) : null;
        R && (R.get || R.set) ? Object.defineProperty(y, M, R) : y[M] = i[M];
      }
    return y.default = i, f && f.set(i, y), y;
  }
  function g(i, n) {
    var f = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var y = Object.getOwnPropertySymbols(i);
      n && (y = y.filter(function(_) {
        return Object.getOwnPropertyDescriptor(i, _).enumerable;
      })), f.push.apply(f, y);
    }
    return f;
  }
  function m(i) {
    for (var n = 1; n < arguments.length; n++) {
      var f = arguments[n] != null ? arguments[n] : {};
      n % 2 ? g(Object(f), !0).forEach(function(y) {
        b(i, y, f[y]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(f)) : g(Object(f)).forEach(function(y) {
        Object.defineProperty(i, y, Object.getOwnPropertyDescriptor(f, y));
      });
    }
    return i;
  }
  function b(i, n, f) {
    return n in i ? Object.defineProperty(i, n, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : i[n] = f, i;
  }
  var c = function(n) {
    return {
      border: 0,
      background: "rgba(0,0,0,0.4)",
      color: "white",
      padding: 10,
      textTransform: "uppercase",
      opacity: n ? 0.3 : 1,
      cursor: n ? "not-allowed" : "pointer"
    };
  }, C = function(n) {
    var f = n.cellAlign, y = n.currentSlide, _ = n.slidesToShow, M = n.wrapAround;
    return M ? !1 : y === 0 || f === "right" && y <= _ - 1;
  };
  V.prevButtonDisabled = C;
  var S = function(n) {
    var f = n.previousSlide, y = n.defaultControlsConfig, _ = y.prevButtonClassName, M = y.prevButtonStyle, R = M === void 0 ? {} : M, O = y.prevButtonText, A = y.prevButtonOnClick, B = n.carouselId, u = n.onUserNavigation, h = n.previousDisabled, o = function(I) {
      A == null || A(I), !I.defaultPrevented && (u(I), I.preventDefault(), f());
    };
    return /* @__PURE__ */ r.default.createElement("button", {
      className: _,
      style: m(m({}, c(h)), R),
      disabled: h,
      onClick: o,
      "aria-label": "previous",
      "aria-controls": "".concat(B, "-slider-frame"),
      type: "button"
    }, O || "Prev");
  };
  V.PreviousButton = S;
  var s = function(n) {
    var f = n.cellAlign, y = n.currentSlide, _ = n.slideCount, M = n.slidesToShow, R = n.wrapAround;
    return R ? !1 : y >= _ - 1 || f === "left" && y >= _ - M;
  };
  V.nextButtonDisabled = s;
  var w = function(n) {
    var f = n.nextSlide, y = n.defaultControlsConfig, _ = y.nextButtonClassName, M = y.nextButtonStyle, R = M === void 0 ? {} : M, O = y.nextButtonText, A = y.nextButtonOnClick, B = n.carouselId, u = n.nextDisabled, h = n.onUserNavigation, o = function(I) {
      A == null || A(I), !I.defaultPrevented && (h(I), I.preventDefault(), f());
    };
    return /* @__PURE__ */ r.default.createElement("button", {
      className: _,
      style: m(m({}, c(u)), R),
      disabled: u,
      onClick: o,
      "aria-label": "next",
      "aria-controls": "".concat(B, "-slider-frame"),
      type: "button"
    }, O || "Next");
  };
  V.NextButton = w;
  var v = function(n, f, y, _, M, R) {
    var O = [], A = f <= 0 ? 1 : f;
    if (M) {
      for (var B = 0; B < n; B += A)
        O.push(B);
      return O;
    }
    if (R === "center") {
      for (var u = 0; u < n - 1; u += A)
        O.push(u);
      return n > 0 && O.push(n - 1), O;
    }
    if (R === "left") {
      if (_ >= n)
        return [0];
      for (var h = n - _, o = 0; o < h; o += A)
        O.push(o);
      return y === t.ScrollMode.remainder ? O.push(h) : O.push(O[O.length - 1] + A), O;
    }
    if (R === "right") {
      if (_ >= n)
        return [n - 1];
      var D = _ - 1;
      if (y === t.ScrollMode.remainder) {
        for (var I = D; I < n - 1; I += A)
          O.push(I);
        O.push(n - 1);
      } else {
        for (var T = n - 1; T > D; T -= A)
          O.push(T);
        O.push(O[O.length - 1] - A), O.reverse();
      }
      return O;
    }
    return O;
  };
  V.getDotIndexes = v;
  var p = function(n) {
    var f = n.pagingDotsIndices, y = n.defaultControlsConfig, _ = y.pagingDotsContainerClassName, M = y.pagingDotsClassName, R = y.pagingDotsStyle, O = R === void 0 ? {} : R, A = y.pagingDotsOnClick, B = n.carouselId, u = n.currentSlide, h = n.onUserNavigation, o = n.slideCount, D = n.goToSlide, I = n.tabbed, T = {
      position: "relative",
      top: -10,
      display: "flex",
      margin: 0,
      padding: 0,
      listStyleType: "none"
    }, N = (0, r.useCallback)(function(E) {
      return {
        cursor: "pointer",
        opacity: E ? 1 : 0.5,
        background: "transparent",
        border: "none",
        fill: "black"
      };
    }, []), j = (0, a.getBoundedIndex)(u, o);
    return I ? /* @__PURE__ */ r.default.createElement("div", {
      className: _,
      style: T,
      "aria-label": "Choose slide to display.",
      role: "tablist"
    }, f.map(function(E, q) {
      var G = j === E || // sets navigation dots active if the current slide falls in the current index range
      j < E && (q === 0 || j > f[q - 1]);
      return /* @__PURE__ */ r.default.createElement("button", {
        key: E,
        className: ["paging-item", M, G ? "active" : null].join(" "),
        type: "button",
        style: m(m({}, N(G)), O),
        onClick: function(ue) {
          A == null || A(ue), !ue.defaultPrevented && (h(ue), D(E));
        },
        "aria-label": "slide ".concat(E + 1),
        "aria-selected": G,
        "aria-controls": "".concat(B, "-slide-").concat(E + 1),
        role: "tab"
      }, /* @__PURE__ */ r.default.createElement("svg", {
        className: "paging-dot",
        width: "6",
        height: "6",
        "aria-hidden": "true",
        focusable: "false",
        viewBox: "0 0 6 6"
      }, /* @__PURE__ */ r.default.createElement("circle", {
        cx: "3",
        cy: "3",
        r: "3"
      })));
    })) : null;
  };
  return V.PagingDots = p, V;
}
var ke = {};
Object.defineProperty(ke, "__esModule", {
  value: !0
});
ke.useTween = void 0;
var pe = re;
function ln(e, r) {
  return dn(e) || fn(e, r) || cn(e, r) || sn();
}
function sn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cn(e, r) {
  if (e) {
    if (typeof e == "string") return zt(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return zt(e, r);
  }
}
function zt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++)
    a[t] = e[t];
  return a;
}
function fn(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], d = !0, l = !1, g, m;
    try {
      for (t = t.call(e); !(d = (g = t.next()).done) && (a.push(g.value), !(r && a.length === r)); d = !0)
        ;
    } catch (b) {
      l = !0, m = b;
    } finally {
      try {
        !d && t.return != null && t.return();
      } finally {
        if (l) throw m;
      }
    }
    return a;
  }
}
function dn(e) {
  if (Array.isArray(e)) return e;
}
var vn = function(r, t, a, d) {
  var l = (0, pe.useState)(1), g = ln(l, 2), m = g[0], b = g[1], c = (0, pe.useRef)(Date.now()), C = (0, pe.useRef)(), S = (0, pe.useRef)(!0), s = (0, pe.useRef)(null), w = s.current === null || s.current === a || d ? m : 0;
  return (0, pe.useEffect)(function() {
    if (s.current = a, S.current) {
      S.current = !1;
      return;
    }
    if (!d) {
      c.current = Date.now(), b(0);
      var v = function p() {
        C.current = requestAnimationFrame(function() {
          var i = Date.now(), n = Math.min(1, (i - c.current) / r);
          b(n), n < 1 ? p() : C.current = void 0;
        });
      };
      return v(), function() {
        C.current !== void 0 && (cancelAnimationFrame(C.current), b(1));
      };
    }
  }, [a, r, d]), {
    isAnimating: w !== 1,
    value: t(w)
  };
};
ke.useTween = vn;
function ot(e) {
  "@babel/helpers - typeof";
  return ot = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, ot(e);
}
Object.defineProperty(ge, "__esModule", {
  value: !0
});
ge.getPercentOffsetForSlide = ge.SliderList = void 0;
var Ze = yn(re), pn = ye(), gn = ke;
function Qt(e) {
  if (typeof WeakMap != "function") return null;
  var r = /* @__PURE__ */ new WeakMap(), t = /* @__PURE__ */ new WeakMap();
  return (Qt = function(d) {
    return d ? t : r;
  })(e);
}
function yn(e, r) {
  if (e && e.__esModule)
    return e;
  if (e === null || ot(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = Qt(r);
  if (t && t.has(e))
    return t.get(e);
  var a = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var l in e)
    if (l !== "default" && Object.prototype.hasOwnProperty.call(e, l)) {
      var g = d ? Object.getOwnPropertyDescriptor(e, l) : null;
      g && (g.get || g.set) ? Object.defineProperty(a, l, g) : a[l] = e[l];
    }
  return a.default = e, t && t.set(e, a), a;
}
var ut = function(r, t, a, d, l) {
  var g = l ? 3 * t : t, m = 100 / g, b = l ? -100 / 3 : 0;
  if (d === "right" && a > 1) {
    var c = a - 1;
    b += m * c;
  }
  if (d === "center" && a > 1) {
    var C = a - 1, S = C / 2;
    b += m * S;
  }
  var s = 100 / g * r;
  return b - s;
};
ge.getPercentOffsetForSlide = ut;
var Zt = /* @__PURE__ */ Ze.default.forwardRef(function(e, r) {
  var t = e.animation, a = e.animationDistance, d = e.cellAlign, l = e.children, g = e.currentSlide, m = e.disableAnimation, b = e.disableEdgeSwiping, c = e.draggedOffset, C = e.easing, S = e.edgeEasing, s = e.isDragging, w = e.scrollMode, v = e.slideCount, p = e.slidesToScroll, i = e.slidesToShow, n = e.speed, f = e.wrapAround, y = e.slideWidth, _ = e.setIsAnimating, M = f ? 3 * v : v, R = y ? "calc(".concat(y, " * ").concat(M, ")") : "".concat(M * 100 / i, "%"), O = [v, i, d, f], A = (0, pn.getDotIndexes)(v, p, w, i, f, d), B = "".concat(c, "px");
  if (s && b && !f) {
    var u = [A[0], A[A.length - 1]].map(function(E) {
      return ut.apply(void 0, [E].concat(O));
    });
    B = "clamp(".concat(u[1], "%, ").concat(c, "px, ").concat(u[0], "%)");
  }
  var h = ut.apply(void 0, [g].concat(O)), o = !b && !f && (g === A[0] && a < 0 || g === A[A.length - 1] && a > 0), D = (0, gn.useTween)(
    n,
    o ? S : C,
    // animationDistance is assumed to be unique enough that it can be used to
    // detect when a new animation should start. This is used in addition to
    // currentSlide because some animations, such as those with edgeEasing, do
    // not occur due to a change in value of currentSlide
    g + a,
    s || m || t === "fade"
  ), I = D.value, T = D.isAnimating, N;
  if (s || h !== 0 || T)
    if (s)
      N = "translateX(".concat(B, ")");
    else {
      var j = T ? (1 - I) * a : 0;
      N = "translateX(calc(".concat(h, "% - ").concat(j, "px))");
    }
  return (0, Ze.useEffect)(function() {
    _(T);
  }, [T, _]), /* @__PURE__ */ Ze.default.createElement("div", {
    ref: r,
    className: "slider-list",
    style: {
      width: R,
      textAlign: "left",
      userSelect: "auto",
      transform: N,
      display: "flex"
    }
  }, l);
});
ge.SliderList = Zt;
Zt.displayName = "SliderList";
var er = {}, We = {};
Object.defineProperty(We, "__esModule", {
  value: !0
});
We.getControlContainerStyles = void 0;
var $ = H;
function Ft(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(d) {
      return Object.getOwnPropertyDescriptor(e, d).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function qt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Ft(Object(t), !0).forEach(function(a) {
      mn(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ft(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function mn(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
var hn = {
  position: "absolute",
  display: "flex",
  zIndex: 1,
  top: 0,
  left: 0,
  bottom: 0,
  right: 0
}, bn = function(r) {
  var t;
  switch (r) {
    case $.Positions.TopLeft:
    case $.Positions.TopCenter:
    case $.Positions.TopRight:
      t = "flex-start";
      break;
    case $.Positions.CenterLeft:
    case $.Positions.CenterCenter:
    case $.Positions.CenterRight:
      t = "center";
      break;
    case $.Positions.BottomLeft:
    case $.Positions.BottomCenter:
    case $.Positions.BottomRight:
      t = "flex-end";
      break;
  }
  var a;
  switch (r) {
    case $.Positions.TopLeft:
    case $.Positions.CenterLeft:
    case $.Positions.BottomLeft:
      a = "flex-start";
      break;
    case $.Positions.TopCenter:
    case $.Positions.CenterCenter:
    case $.Positions.BottomCenter:
      a = "center";
      break;
    case $.Positions.TopRight:
    case $.Positions.CenterRight:
    case $.Positions.BottomRight:
      a = "flex-end";
      break;
  }
  return {
    alignItems: t,
    justifyContent: a
  };
}, Sn = function(r) {
  return qt(qt({}, bn(r)), hn);
};
We.getControlContainerStyles = Sn;
(function(e) {
  function r(v) {
    "@babel/helpers - typeof";
    return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(p) {
      return typeof p;
    } : function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
    }, r(v);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = m(re), a = We, d = ye(), l = H;
  function g(v) {
    if (typeof WeakMap != "function") return null;
    var p = /* @__PURE__ */ new WeakMap(), i = /* @__PURE__ */ new WeakMap();
    return (g = function(f) {
      return f ? i : p;
    })(v);
  }
  function m(v, p) {
    if (v && v.__esModule)
      return v;
    if (v === null || r(v) !== "object" && typeof v != "function")
      return { default: v };
    var i = g(p);
    if (i && i.has(v))
      return i.get(v);
    var n = {}, f = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var y in v)
      if (y !== "default" && Object.prototype.hasOwnProperty.call(v, y)) {
        var _ = f ? Object.getOwnPropertyDescriptor(v, y) : null;
        _ && (_.get || _.set) ? Object.defineProperty(n, y, _) : n[y] = v[y];
      }
    return n.default = v, i && i.set(v, n), n;
  }
  function b(v, p) {
    var i = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(v);
      p && (n = n.filter(function(f) {
        return Object.getOwnPropertyDescriptor(v, f).enumerable;
      })), i.push.apply(i, n);
    }
    return i;
  }
  function c(v) {
    for (var p = 1; p < arguments.length; p++) {
      var i = arguments[p] != null ? arguments[p] : {};
      p % 2 ? b(Object(i), !0).forEach(function(n) {
        C(v, n, i[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(i)) : b(Object(i)).forEach(function(n) {
        Object.defineProperty(v, n, Object.getOwnPropertyDescriptor(i, n));
      });
    }
    return v;
  }
  function C(v, p, i) {
    return p in v ? Object.defineProperty(v, p, { value: i, enumerable: !0, configurable: !0, writable: !0 }) : v[p] = i, v;
  }
  var S = [{
    funcName: "renderTopLeftControls",
    key: l.Positions.TopLeft
  }, {
    funcName: "renderTopCenterControls",
    key: l.Positions.TopCenter
  }, {
    funcName: "renderTopRightControls",
    key: l.Positions.TopRight
  }, {
    funcName: "renderCenterLeftControls",
    key: l.Positions.CenterLeft
  }, {
    funcName: "renderCenterCenterControls",
    key: l.Positions.CenterCenter
  }, {
    funcName: "renderCenterRightControls",
    key: l.Positions.CenterRight
  }, {
    funcName: "renderBottomLeftControls",
    key: l.Positions.BottomLeft
  }, {
    funcName: "renderBottomCenterControls",
    key: l.Positions.BottomCenter
  }, {
    funcName: "renderBottomRightControls",
    key: l.Positions.BottomRight
  }], s = function(p, i, n, f, y, _, M) {
    if (p.withoutControls)
      return null;
    var R = c(c({}, p), {}, {
      currentSlide: n,
      slideCount: i
    }), O = (0, d.nextButtonDisabled)(R), A = (0, d.prevButtonDisabled)(R), B = (0, d.getDotIndexes)(i, M, p.scrollMode, p.slidesToShow, p.wrapAround, p.cellAlign);
    return S.map(function(u) {
      var h;
      return !p[u.funcName] || typeof p[u.funcName] != "function" ? /* @__PURE__ */ t.default.createElement(t.Fragment, {
        key: u.funcName
      }) : /* @__PURE__ */ t.default.createElement("div", {
        key: u.funcName,
        style: c(c({}, (0, a.getControlContainerStyles)(u.key)), {}, {
          pointerEvents: "none"
        })
      }, /* @__PURE__ */ t.default.createElement("div", {
        className: ["slider-control-".concat(u.key.toLowerCase()), p.defaultControlsConfig.containerClassName || ""].join(" ").trim(),
        style: {
          pointerEvents: "auto"
        }
      }, (h = p[u.funcName]) === null || h === void 0 ? void 0 : h.call(p, {
        cellAlign: p.cellAlign,
        cellSpacing: p.cellSpacing,
        currentSlide: n,
        defaultControlsConfig: p.defaultControlsConfig || {},
        carouselId: p.carouselId,
        pagingDotsIndices: B,
        goToSlide: f,
        nextDisabled: O,
        nextSlide: y,
        onUserNavigation: p.onUserNavigation,
        previousDisabled: A,
        previousSlide: _,
        scrollMode: p.scrollMode,
        slideCount: i,
        slidesToScroll: M,
        slidesToShow: p.slidesToShow || 1,
        tabbed: p.tabbed,
        vertical: p.vertical,
        wrapAround: p.wrapAround
      })));
    });
  }, w = s;
  e.default = w;
})(er);
var tr = {};
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var r = l(re), t = H, a = ye(), d = ct;
  function l(c) {
    return c && c.__esModule ? c : { default: c };
  }
  var g = function(C) {
    return Math.pow(C - 1, 3) + 1;
  }, m = {
    adaptiveHeight: !1,
    adaptiveHeightAnimation: !0,
    afterSlide: function() {
    },
    autoplay: !1,
    autoplayInterval: 3e3,
    autoplayReverse: !1,
    beforeSlide: function() {
    },
    carouselId: "nuka-carousel",
    cellAlign: "left",
    cellSpacing: 0,
    defaultControlsConfig: {},
    disableAnimation: !1,
    disableEdgeSwiping: !1,
    dragging: !0,
    dragThreshold: 0.5,
    easing: g,
    edgeEasing: g,
    enableKeyboardControls: !1,
    frameAriaLabel: "Slider",
    keyCodeConfig: {
      nextSlide: [39, 68, 38, 87],
      previousSlide: [37, 65, 40, 83],
      firstSlide: [81],
      lastSlide: [69],
      pause: [32]
    },
    landmark: !1,
    onDragStart: function() {
    },
    onDrag: function() {
    },
    onDragEnd: function() {
    },
    onUserNavigation: function() {
    },
    pauseOnHover: !0,
    renderAnnounceSlideMessage: d.defaultRenderAnnounceSlideMessage,
    renderBottomCenterControls: function(C) {
      return /* @__PURE__ */ r.default.createElement(a.PagingDots, C);
    },
    renderCenterLeftControls: function(C) {
      return /* @__PURE__ */ r.default.createElement(a.PreviousButton, C);
    },
    renderCenterRightControls: function(C) {
      return /* @__PURE__ */ r.default.createElement(a.NextButton, C);
    },
    scrollMode: t.ScrollMode.page,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    style: {},
    swiping: !0,
    tabbed: !0,
    vertical: !1,
    withoutControls: !1,
    wrapAround: !1,
    children: /* @__PURE__ */ r.default.createElement(r.default.Fragment, null)
  }, b = m;
  e.default = b;
})(tr);
var He = {}, Le = {};
Object.defineProperty(Le, "__esModule", {
  value: !0
});
Le.useStateWithRef = void 0;
var et = re;
function Cn(e, r) {
  return _n(e) || Pn(e, r) || wn(e, r) || On();
}
function On() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wn(e, r) {
  if (e) {
    if (typeof e == "string") return Ut(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return Ut(e, r);
  }
}
function Ut(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++)
    a[t] = e[t];
  return a;
}
function Pn(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], d = !0, l = !1, g, m;
    try {
      for (t = t.call(e); !(d = (g = t.next()).done) && (a.push(g.value), !(r && a.length === r)); d = !0)
        ;
    } catch (b) {
      l = !0, m = b;
    } finally {
      try {
        !d && t.return != null && t.return();
      } finally {
        if (l) throw m;
      }
    }
    return a;
  }
}
function _n(e) {
  if (Array.isArray(e)) return e;
}
var Dn = function(r) {
  var t = (0, et.useState)(r), a = Cn(t, 2), d = a[0], l = a[1], g = (0, et.useRef)(r), m = (0, et.useCallback)(function(b) {
    g.current = b, l(b);
  }, []);
  return [d, m, g];
};
Le.useStateWithRef = Dn;
Object.defineProperty(He, "__esModule", {
  value: !0
});
He.useFrameHeight = void 0;
var tt = re, An = Le;
function Vt(e) {
  return xn(e) || In(e) || rr(e) || Mn();
}
function Mn() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function In(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function xn(e) {
  if (Array.isArray(e)) return lt(e);
}
function Kt(e, r) {
  return Tn(e) || Bn(e, r) || rr(e, r) || Rn();
}
function Rn() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rr(e, r) {
  if (e) {
    if (typeof e == "string") return lt(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return lt(e, r);
  }
}
function lt(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, a = new Array(r); t < r; t++)
    a[t] = e[t];
  return a;
}
function Bn(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var a = [], d = !0, l = !1, g, m;
    try {
      for (t = t.call(e); !(d = (g = t.next()).done) && (a.push(g.value), !(r && a.length === r)); d = !0)
        ;
    } catch (b) {
      l = !0, m = b;
    } finally {
      try {
        !d && t.return != null && t.return();
      } finally {
        if (l) throw m;
      }
    }
    return a;
  }
}
function Tn(e) {
  if (Array.isArray(e)) return e;
}
var Nn = function(r, t, a) {
  var d = (0, An.useStateWithRef)([]), l = Kt(d, 3), g = l[0], m = l[1], b = l[2], c = (0, tt.useState)(!1), C = Kt(c, 2), S = C[0], s = C[1], w = (0, tt.useCallback)(function(p, i) {
    var n = b.current, f;
    i === null ? f = n.filter(function(y) {
      return y.slideIndex !== p;
    }) : f = [].concat(Vt(n), [{
      slideIndex: p,
      height: i
    }]), m(f), f.length >= Math.min(a, Math.ceil(t)) && s(!0);
  }, [a, m, t, b]), v = (0, tt.useMemo)(function() {
    if (r) {
      if (!S)
        return "auto";
      var p = Math.max.apply(Math, [0].concat(Vt(g.map(function(i) {
        return i.height;
      }))));
      return "".concat(p, "px");
    } else
      return "auto";
  }, [r, S, g]);
  return {
    handleVisibleSlideHeightChange: w,
    frameHeight: v,
    initializedAdaptiveHeight: S
  };
};
He.useFrameHeight = Nn;
(function(e) {
  function r(u) {
    "@babel/helpers - typeof";
    return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(h) {
      return typeof h;
    } : function(h) {
      return h && typeof Symbol == "function" && h.constructor === Symbol && h !== Symbol.prototype ? "symbol" : typeof h;
    }, r(u);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = e.Carousel = void 0;
  var t = v(re), a = s(Gt), d = s(ct), l = ge, g = H, m = s(er), b = s(tr), c = Jt(), C = He, S = ye();
  function s(u) {
    return u && u.__esModule ? u : { default: u };
  }
  function w(u) {
    if (typeof WeakMap != "function") return null;
    var h = /* @__PURE__ */ new WeakMap(), o = /* @__PURE__ */ new WeakMap();
    return (w = function(I) {
      return I ? o : h;
    })(u);
  }
  function v(u, h) {
    if (u && u.__esModule)
      return u;
    if (u === null || r(u) !== "object" && typeof u != "function")
      return { default: u };
    var o = w(h);
    if (o && o.has(u))
      return o.get(u);
    var D = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var T in u)
      if (T !== "default" && Object.prototype.hasOwnProperty.call(u, T)) {
        var N = I ? Object.getOwnPropertyDescriptor(u, T) : null;
        N && (N.get || N.set) ? Object.defineProperty(D, T, N) : D[T] = u[T];
      }
    return D.default = u, o && o.set(u, D), D;
  }
  function p(u, h) {
    var o = Object.keys(u);
    if (Object.getOwnPropertySymbols) {
      var D = Object.getOwnPropertySymbols(u);
      h && (D = D.filter(function(I) {
        return Object.getOwnPropertyDescriptor(u, I).enumerable;
      })), o.push.apply(o, D);
    }
    return o;
  }
  function i(u) {
    for (var h = 1; h < arguments.length; h++) {
      var o = arguments[h] != null ? arguments[h] : {};
      h % 2 ? p(Object(o), !0).forEach(function(D) {
        n(u, D, o[D]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(o)) : p(Object(o)).forEach(function(D) {
        Object.defineProperty(u, D, Object.getOwnPropertyDescriptor(o, D));
      });
    }
    return u;
  }
  function n(u, h, o) {
    return h in u ? Object.defineProperty(u, h, { value: o, enumerable: !0, configurable: !0, writable: !0 }) : u[h] = o, u;
  }
  function f(u, h) {
    return O(u) || R(u, h) || _(u, h) || y();
  }
  function y() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function _(u, h) {
    if (u) {
      if (typeof u == "string") return M(u, h);
      var o = Object.prototype.toString.call(u).slice(8, -1);
      if (o === "Object" && u.constructor && (o = u.constructor.name), o === "Map" || o === "Set") return Array.from(u);
      if (o === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o)) return M(u, h);
    }
  }
  function M(u, h) {
    (h == null || h > u.length) && (h = u.length);
    for (var o = 0, D = new Array(h); o < h; o++)
      D[o] = u[o];
    return D;
  }
  function R(u, h) {
    var o = u == null ? null : typeof Symbol < "u" && u[Symbol.iterator] || u["@@iterator"];
    if (o != null) {
      var D = [], I = !0, T = !1, N, j;
      try {
        for (o = o.call(u); !(I = (N = o.next()).done) && (D.push(N.value), !(h && D.length === h)); I = !0)
          ;
      } catch (E) {
        T = !0, j = E;
      } finally {
        try {
          !I && o.return != null && o.return();
        } finally {
          if (T) throw j;
        }
      }
      return D;
    }
  }
  function O(u) {
    if (Array.isArray(u)) return u;
  }
  var A = function(h) {
    var o = h, D = o.adaptiveHeight, I = o.adaptiveHeightAnimation, T = o.afterSlide, N = o.animation, j = o.autoplay, E = o.autoplayInterval, q = o.autoplayReverse, G = o.beforeSlide, J = o.carouselId, ue = o.cellAlign, $e = o.cellSpacing, le = o.children, me = o.className, he = o.disableAnimation, be = o.dragging, ar = o.dragThreshold, ft = o.enableKeyboardControls, ir = o.frameAriaLabel, or = o.innerRef, dt = o.keyCodeConfig, ur = o.landmark, vt = o.onDrag, lr = o.onDragEnd, fe = o.onDragStart, Pe = o.onUserNavigation, _e = o.pauseOnHover, sr = o.renderAnnounceSlideMessage, cr = o.scrollMode, ce = o.slideIndex, De = o.slidesToScroll, fr = o.slidesToShow, Ae = o.slideWidth, Me = o.speed, dr = o.style, pt = o.swiping, vr = o.tabbed, K = o.wrapAround, pr = o.zoomScale, gt = t.default.Children.toArray(le).filter(Boolean), X = gt.length, Q = Ae || De === "auto" ? "left" : ue, ae = De === "auto" ? g.ScrollMode.remainder : cr, gr = (0, t.useState)(/* @__PURE__ */ new Map()), yt = f(gr, 2), je = yt[0], yr = yt[1], ze = Array.from(je).filter(function(P) {
      var x = f(P, 2), W = x[1];
      return W;
    }).length, mr = (0, t.useState)(ze), mt = f(mr, 2), ht = mt[0], hr = mt[1], U = Ae ? ht : fr, Y = N === "fade" ? U : De === "auto" ? Math.max(ht, 1) : De, br = (0, t.useState)(function() {
      return (0, c.getDefaultSlideIndex)(ce, X, U, Y, Q, q, ae);
    }), bt = f(br, 2), z = bt[0], Sr = bt[1], Cr = (0, t.useState)(!1), St = f(Cr, 2), de = St[0], Fe = St[1], Or = (0, t.useState)(!1), Ct = f(Or, 2), Z = Ct[0], qe = Ct[1], wr = (0, t.useState)(0), Ot = f(wr, 2), Se = Ot[0], wt = Ot[1], Pr = (0, t.useState)(0), Pt = f(Pr, 2), _r = Pt[0], Dr = Pt[1], Ar = (0, t.useState)(!1), _t = f(Ar, 2), Dt = _t[0], Mr = _t[1], Ir = (0, t.useCallback)(function(P, x) {
      !!je.get(P) !== x && yr(function(W) {
        var F = new Map(W);
        return F.set(P, x), F;
      });
    }, [je]), Ue = (0, t.useRef)(!1);
    (0, t.useEffect)(function() {
      Z && (Ue.current = !0), Z || Dt || (Ue.current || hr(ze), Ue.current = !1);
    }, [Dt, Z, ze]);
    var Ce = (0, t.useRef)(null), Ve = (0, t.useRef)(0), se = (0, t.useRef)(null), xr = (0, t.useRef)(null), Ke = (0, t.useRef)(), Oe = (0, t.useRef)(null), Xe = (0, t.useRef)(!0), Rr = (0, t.useCallback)(function(P) {
      P && P.querySelectorAll(".slider-list img").forEach(function(x) {
        return x.setAttribute("draggable", "false");
      }), se.current = P;
    }, []);
    (0, t.useEffect)(function() {
      return Xe.current = !0, function() {
        Xe.current = !1;
      };
    }, []);
    var k = or || xr, ee = (0, t.useCallback)(function(P) {
      if (!(!se.current || !k.current)) {
        var x = (0, c.getBoundedIndex)(P, X), W = P !== z;
        W && G(z, x);
        var F = se.current.getBoundingClientRect().left - k.current.getBoundingClientRect().left, L = se.current.offsetWidth, oe = (0, l.getPercentOffsetForSlide)(x, X, U, Q, K) / 100 * L;
        if (K) {
          var Be = L / 3;
          P < 0 && (oe += Be), P >= X && (oe -= Be);
        }
        if (Dr(oe - F), W) {
          Sr(x);
          var Je = he ? 40 : Me || 500;
          setTimeout(function() {
            Xe.current && T(x);
          }, Je);
        }
      }
    }, [T, G, k, Q, z, he, Me, X, U, K]), Ie = (0, t.useCallback)(function() {
      var P = (0, c.getNextMoveIndex)(ae, K, z, X, Y, U, Q);
      z !== P && ee(P);
    }, [Q, z, ee, Y, ae, X, U, K]), xe = (0, t.useCallback)(function() {
      var P = (0, c.getPrevMoveIndex)(ae, K, z, Y, U, Q);
      z !== P && ee(P);
    }, [Q, z, ee, Y, ae, U, K]), At = (0, t.useRef)(ce);
    (0, t.useEffect)(function() {
      ce !== void 0 && ce !== At.current && !q && (ee(ce), At.current = ce);
    }, [ce, q, ee]), (0, t.useEffect)(function() {
      var P = null;
      return de && (P = Date.now()), function() {
        P !== null && Oe.current !== null && (Oe.current += Date.now() - P);
      };
    }, [de]), (0, t.useEffect)(function() {
      if (j && !de) {
        var P = Oe.current !== null ? E - (Date.now() - Oe.current) : E;
        Ke.current = setTimeout(function() {
          Oe.current = Date.now(), q ? xe() : Ie();
        }, P);
      }
      return j && de && clearTimeout(Ke.current), function() {
        clearTimeout(Ke.current);
      };
    }, [de, j, E, q, xe, Ie]);
    var Br = function(x) {
      var W = null;
      if (Object.keys(dt).forEach(function(L) {
        var oe;
        (oe = dt[L]) !== null && oe !== void 0 && oe.includes(x.keyCode) && (W = L);
      }), W !== null)
        switch (x.preventDefault(), x.stopPropagation(), W) {
          case "nextSlide":
            Pe(x), Ie();
            break;
          case "previousSlide":
            Pe(x), xe();
            break;
          case "firstSlide":
          case "lastSlide": {
            Pe(x);
            var F = (0, S.getDotIndexes)(X, Y, ae, U, K, Q);
            ee(W === "firstSlide" ? F[0] : F[F.length - 1]);
            break;
          }
          case "pause":
            Fe(function(L) {
              return !L;
            });
            break;
        }
    }, ie = (0, t.useRef)([]), Mt = function(x) {
      if (!(!Z || !k.current)) {
        qe(!1);
        var W = 0;
        if (ie.current.length > 1)
          for (var F = ie.current[0], L = ie.current[ie.current.length - 1], oe = L.time - F.time, Be = 9, Je = 0.92, zr = Be * Math.abs((L.pos - F.pos) / oe), Qe = zr; Math.abs(Qe) > 1; )
            W += Qe, Qe *= Je;
        ie.current = [];
        var xt = Math.abs(Se) + Math.abs(W);
        lr(x), Ce.current = null, wt(0);
        var Rt = k.current.offsetWidth * Math.min(1, Y / U), Bt = Rt * ar;
        if (xt < Bt) {
          ee(z);
          return;
        }
        for (var Fr = U >= 2 * Y, qr = Fr ? 1 + Math.floor((xt - Bt) / Rt) : 1, ve = z, Tt = 0; Tt < qr; Tt += 1)
          Se > 0 ? ve = (0, c.getNextMoveIndex)(ae, K, ve, X, Y, U, Q) : ve = (0, c.getPrevMoveIndex)(ae, K, ve, Y, U, Q);
        ve !== z && Pe(x), ee(ve);
      }
    }, Tr = (0, t.useCallback)(function(P) {
      !pt || !se.current || !k.current || (qe(!0), Ve.current = se.current.getBoundingClientRect().left - k.current.getBoundingClientRect().left, fe(P));
    }, [k, fe, pt]), Re = (0, t.useCallback)(function(P) {
      if (Z) {
        for (var x = Ce.current === null, W = Ce.current !== null ? P - Ce.current : 0, F = Se + W, L = Date.now(); ie.current.length > 0 && !(L - ie.current[0].time <= 100); )
          ie.current.shift();
        ie.current.push({
          pos: F,
          time: L
        }), x || wt(F), Ce.current = P;
      }
    }, [Z, Se]), Nr = (0, t.useCallback)(function(P) {
      if (!(!Z || !k.current)) {
        fe(P);
        var x = k.current.offsetWidth - P.touches[0].pageX;
        Re(x);
      }
    }, [Z, k, Re, fe]), Er = (0, t.useCallback)(function(P) {
      !be || !se.current || !k.current || (qe(!0), Ve.current = se.current.getBoundingClientRect().left - k.current.getBoundingClientRect().left, fe(P));
    }, [k, be, fe]), kr = (0, t.useCallback)(function(P) {
      if (!(!Z || !k.current)) {
        vt(P);
        var x = P.clientX - k.current.getBoundingClientRect().left, W = k.current.offsetWidth - x;
        Re(W);
      }
    }, [k, Z, Re, vt]), It = function(x) {
      x.preventDefault(), Mt(x);
    }, Wr = (0, t.useCallback)(function() {
      _e && Fe(!0);
    }, [_e]), Hr = (0, t.useCallback)(function() {
      _e && Fe(!1);
    }, [_e]), Ye = (0, C.useFrameHeight)(D, U, X), Lr = Ye.frameHeight, $r = Ye.handleVisibleSlideHeightChange, jr = Ye.initializedAdaptiveHeight, Ge = function(x) {
      var W = gt.map(function(F, L) {
        return /* @__PURE__ */ t.default.createElement(a.default, {
          key: "".concat(x, "-").concat(L),
          id: "".concat(x, "-").concat(L),
          carouselId: J,
          count: X,
          index: L,
          isCurrentSlide: z === L,
          typeOfSlide: x,
          wrapAround: K,
          cellSpacing: $e,
          animation: N,
          speed: Me,
          zoomScale: pr,
          onVisibleSlideHeightChange: $r,
          slideWidth: Ae,
          updateIOEntry: Ir,
          adaptiveHeight: D,
          initializedAdaptiveHeight: jr,
          carouselRef: k,
          tabbed: vr
        }, F);
      });
      return W;
    };
    return /* @__PURE__ */ t.default.createElement("div", {
      className: "slider-container",
      style: {
        position: "relative"
      },
      onMouseEnter: Wr,
      onMouseLeave: Hr,
      "aria-label": ir,
      role: ur ? "region" : "group",
      "aria-roledescription": "carousel",
      id: J,
      "data-testid": J
    }, /* @__PURE__ */ t.default.createElement(d.default, {
      ariaLive: j && !de ? "off" : "polite",
      message: sr({
        currentSlide: z,
        count: X
      })
    }), (0, m.default)(o, X, z, ee, Ie, xe, Y), /* @__PURE__ */ t.default.createElement("div", {
      className: ["slider-frame", me || ""].join(" ").trim(),
      style: i({
        overflow: "hidden",
        width: "100%",
        position: "relative",
        outline: "none",
        touchAction: "pan-y",
        height: Lr,
        transition: I ? "height 300ms ease-in-out" : void 0,
        willChange: "height",
        userSelect: "none"
      }, dr),
      tabIndex: ft ? 0 : -1,
      onKeyDown: ft ? Br : void 0,
      ref: k,
      onMouseUp: It,
      onMouseDown: Er,
      onMouseMove: kr,
      onMouseLeave: It,
      onTouchStart: Tr,
      onTouchEnd: Mt,
      onTouchMove: Nr,
      id: "".concat(J, "-slider-frame"),
      "data-testid": "".concat(J, "-slider-frame")
    }, /* @__PURE__ */ t.default.createElement(l.SliderList, {
      animationDistance: _r,
      cellAlign: Q,
      currentSlide: z,
      disableEdgeSwiping: o.disableEdgeSwiping,
      draggedOffset: Ve.current - Se,
      disableAnimation: he,
      easing: o.easing,
      edgeEasing: o.edgeEasing,
      isDragging: Z,
      ref: Rr,
      scrollMode: ae,
      animation: N,
      slideCount: X,
      slidesToScroll: Y,
      slidesToShow: U,
      speed: Me,
      slideWidth: Ae,
      wrapAround: K,
      setIsAnimating: Mr
    }, K ? Ge("prev-cloned") : null, Ge(), K ? Ge("next-cloned") : null)));
  };
  e.Carousel = A, A.defaultProps = b.default;
  var B = A;
  e.default = B;
})(Yt);
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = {
    NextButton: !0,
    PreviousButton: !0,
    PagingDots: !0
  };
  Object.defineProperty(e, "NextButton", {
    enumerable: !0,
    get: function() {
      return d.NextButton;
    }
  }), Object.defineProperty(e, "PagingDots", {
    enumerable: !0,
    get: function() {
      return d.PagingDots;
    }
  }), Object.defineProperty(e, "PreviousButton", {
    enumerable: !0,
    get: function() {
      return d.PreviousButton;
    }
  }), Object.defineProperty(e, "default", {
    enumerable: !0,
    get: function() {
      return t.Carousel;
    }
  });
  var t = Yt, a = H;
  Object.keys(a).forEach(function(l) {
    l === "default" || l === "__esModule" || Object.prototype.hasOwnProperty.call(r, l) || l in e && e[l] === a[l] || Object.defineProperty(e, l, {
      enumerable: !0,
      get: function() {
        return a[l];
      }
    });
  });
  var d = ye();
})(st);
const En = /* @__PURE__ */ Ur(st), kn = En, nr = ({ icon: e, ...r }) => /* @__PURE__ */ ne.jsx(
  en,
  {
    state: "dark",
    buttonType: "primary",
    size: "sm",
    icon: e,
    ...r
  }
), Wn = ({
  previousDisabled: e,
  previousSlide: r
}) => /* @__PURE__ */ ne.jsx(
  nr,
  {
    icon: /* @__PURE__ */ ne.jsx(Xt, {}),
    disabled: e,
    title: "Previous Item",
    onClick: r
  }
), Hn = ({ nextDisabled: e, nextSlide: r }) => /* @__PURE__ */ ne.jsx(
  nr,
  {
    icon: /* @__PURE__ */ ne.jsx(Xt, {}),
    disabled: e,
    onClick: r,
    title: "Next Item"
  }
), Ln = ({ percentage: e }) => /* @__PURE__ */ ne.jsx("div", { className: "cur-mx-5 cur-mt-10 cur-h-1 cur-bg-surface-neutral", children: /* @__PURE__ */ ne.jsx(
  "div",
  {
    style: { width: `${e}%` },
    className: "cur-h-full cur-bg-brand cur-transition-all"
  }
) }), $n = (e) => {
  const [r, t] = Vr(), a = (t == null ? void 0 : t.width) || 0, [d] = Kr();
  return [
    r,
    we(() => {
      if (typeof e == "number" || typeof e == "string")
        return kt(e);
      if (typeof e.componentSizes == "object") {
        const l = Object.keys(e.componentSizes), g = Ht(l, a);
        if (g > -1)
          return e.componentSizes[l[g]];
      }
      if (typeof e.windowSizes == "object") {
        const l = Object.keys(e.windowSizes).map((c) => Number.isNaN(parseFloat(c)) && Object.prototype.hasOwnProperty.call(Wt, c) ? Wt[c] : kt(c)).sort(), g = Ht(l, d), m = e.windowSizes[l[g]];
        if (m)
          return m;
        const b = Qr.indexOf(l[g]);
        if (b !== -1) {
          const c = Zr[b];
          return e.windowSizes[c];
        }
        return 1;
      }
    }, [e, a, d])
  ];
}, jn = (e, r, t, a) => we(() => !e || !r || !a ? 0 : Math.min(1, (t + a) / r) * 100, [e, r, t, a]), zn = () => {
  const e = Ne(null), {
    width: r = 0,
    height: t = 0,
    left: a = 0,
    top: d = 0
  } = Yr(e) || {};
  return we(
    () => [
      e,
      [
        [a + (r - r / 5), a + r],
        [d, d + t]
      ]
    ],
    [r, t, a, d]
  );
}, na = Gr(
  "Carousel",
  Jr(
    ({
      cellSpacing: e = 0,
      children: r,
      className: t,
      controls: a = !1,
      onClick: d,
      progress: l = !1,
      slidesToShow: g = 1,
      ...m
    }, b) => {
      const [c, C] = $n(g), S = we(
        () => C ? Math.floor(C) : 1,
        [C]
      ), s = e ? -(e / 2) : void 0, w = we(
        () => ({
          marginLeft: s,
          marginRight: s,
          width: `calc(100% + ${e}px)`
        }),
        [s, e]
      ), v = Ne(0), p = Ne(0), i = Ne(null), n = jn(
        l,
        v.current,
        p.current,
        C || 0
      ), f = Nt((O) => (v.current = O.slideCount, p.current = O.currentSlide, i.current = O.nextSlide, null), []), [y, _] = zn(), M = Nt(
        (O) => {
          var I;
          const { pageX: A, pageY: B } = O, [[u, h], [o, D]] = _;
          !a && A >= u && A < h && B >= o && B < D && ((I = i.current) == null || I.call(i)), d == null || d(O);
        },
        [d, a, i, _]
      ), R = Xr(b, c);
      return /* @__PURE__ */ ne.jsxs(
        "div",
        {
          ref: R,
          className: Et("cur-overflow-hidden", t),
          onClick: M,
          tabIndex: -1,
          role: "listbox",
          ...m,
          children: [
            /* @__PURE__ */ ne.jsx(
              kn,
              {
                cellAlign: "left",
                cellSpacing: e,
                className: Et({
                  "cur-p-[1.25rem]": a
                }),
                innerRef: y,
                renderBottomCenterControls: f,
                renderCenterLeftControls: a ? Wn : null,
                renderCenterRightControls: a ? Hn : null,
                scrollMode: st.ScrollMode.remainder,
                slidesToScroll: S,
                slidesToShow: (C || 0) + (a ? 0 : 0.25),
                style: w,
                wrapAround: !a,
                children: r
              }
            ),
            a && l ? /* @__PURE__ */ ne.jsx(Ln, { percentage: n }) : null
          ]
        }
      );
    }
  )
);
export {
  na as Carousel
};
//# sourceMappingURL=index.js.map
